import { Component } from '@angular/core';
import { SettingsService } from '../service/settings.service';
import { SettingsDialogComponent } from '../settings-dialog/settings-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-context-id-selector',
    templateUrl: './context-id-selector.component.html',
    styleUrls: ['./context-id-selector.component.css'],
    standalone: false
})
export class ContextIdSelectorComponent {
  contextIds:any
  settingData:any
  userData:any
  accountName:any

  constructor(private settingsService: SettingsService,
    public dialog: MatDialog,
    private router: Router,
    private translate:TranslateService
  ){}

  ngOnInit():void{
    this.openDialogSettings()  
  }

  openDialogSettings():void{
    let dialogRef= this.dialog.open(SettingsDialogComponent, {
      data: { 
        values: this.userData,
        title:this.translate.instant('selectContext')

      },
    });

    dialogRef.afterClosed().subscribe(async (result:any) => {
      //console.log(result)
      try{
        const contextId = result?.[0]?.id
        if (!contextId) {
          return
        }

        this.settingsService.updateContextId(contextId)
        await this.router.navigate(['home', contextId])
      }catch(error){
        console.log(error)
      }
      
    });
    this.settingsService.changeAccount=false
  }
}
